// lazysizes removed: native loading="lazy" is supported in all target browsers
// and is set on gatsby-remark-images via `loading: 'lazy'` in gatsby-config.js.

import React from "react";
import { MDXProvider } from "@mdx-js/react";
import { mdxComponents } from "./src/mdx-components";

// gatsby-plugin-mdx v5 expects components to be provided via MDXProvider at
// the root so embedded JSX (<More>, <YoutubePlayer>, etc.) inside .md/.mdx
// files resolves to our React components.
export const wrapRootElement = ({ element }) => (
  <MDXProvider components={mdxComponents}>{element}</MDXProvider>
);

// appt-now SDK is now injected via gatsby-ssr.js with defer — loaded during
// HTML parse, executed before DOMContentLoaded, ready before React hydration.
// Removed the previous window.onload approach that bound after hydration
// and missed buttons.
